import { render, staticRenderFns } from "./green-credit.vue?vue&type=template&id=a40c0944&scoped=true&lang=pug&"
import script from "./green-credit.vue?vue&type=script&lang=js&"
export * from "./green-credit.vue?vue&type=script&lang=js&"
import style0 from "./green-credit.vue?vue&type=style&index=0&id=a40c0944&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40c0944",
  null
  
)

export default component.exports